module.exports = __webpack_public_path__ + "img/BFA.0a8bd0bf.svg";